import { render, staticRenderFns } from "./match_operations_home.vue?vue&type=template&id=59313f52&scoped=true&"
import script from "./match_operations_home.vue?vue&type=script&lang=js&"
export * from "./match_operations_home.vue?vue&type=script&lang=js&"
import style0 from "./match_operations_home.vue?vue&type=style&index=0&id=59313f52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59313f52",
  null
  
)

export default component.exports